var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type-label"},[_c('span',{staticClass:"tag",class:_vm.cssClass},[_vm._v(_vm._s(_vm.tag.toUpperCase()))]),(_vm.label)?_c('span',{staticClass:"broadcast-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }